import { useAuthorizedAppInit } from 'hooks/use-authorized-app-init/use-authorized-app-init';
import { useAutoLogout } from 'hooks/use-auto-logout/use-auto-logout';
import { useDataLoader } from 'hooks/use-data-loader/use-data-loader';
import { useOrganizationList } from 'hooks/use-organization-list/use-organization-list';
import { useRunOnce } from 'hooks/use-run-once/use-run-once';

export function AuthorizedAppInit() {
  useDataLoader();
  const initAuthorizedApp = useAuthorizedAppInit();
  const { areOrganizationRecordsLoading } = useOrganizationList({ fetchTrials: true });
  const initEnabled = !areOrganizationRecordsLoading;

  useRunOnce(initAuthorizedApp, initEnabled);

  useAutoLogout();

  return null;
}
